import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';

import { messagingQueryKeys } from './queryKeys';

export const useMessageThreadQuery = (threadId: string | null) =>
  useQuery({
    queryKey: messagingQueryKeys.thread(threadId),
    queryFn: threadId
      ? async ({ signal }) => {
          const { data } = await fetchClient.GET(endpoints.thread, {
            params: { path: { id: threadId } },
            signal,
          });
          return data;
        }
      : skipToken,
  });
